/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefundTabRequest
 */
export interface RefundTabRequest {
    /**
     * 
     * @type {string}
     * @memberof RefundTabRequest
     */
    reason: string;
    /**
     * 
     * @type {number}
     * @memberof RefundTabRequest
     */
    amount: number;
}

/**
 * Check if a given object implements the RefundTabRequest interface.
 */
export function instanceOfRefundTabRequest(value: object): value is RefundTabRequest {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function RefundTabRequestFromJSON(json: any): RefundTabRequest {
    return RefundTabRequestFromJSONTyped(json, false);
}

export function RefundTabRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefundTabRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'amount': json['amount'],
    };
}

export function RefundTabRequestToJSON(json: any): RefundTabRequest {
    return RefundTabRequestToJSONTyped(json, false);
}

export function RefundTabRequestToJSONTyped(value?: RefundTabRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'amount': value['amount'],
    };
}

